import { JsCarousel } from '../../components/carousels/JsCarousel';
import { CollectionHubCarouselTracking } from './tracking/CollectionHubCarouselTracking';
import { GenericCarouselTracking } from './tracking/GenericCarouselTracking';
import { BrandsCarouselTracking } from './tracking/BrandsCarouselTracking';
import { ListCarouselTracking } from './tracking/ListCarouselTracking';
import { YouMightAlsoLikeCarouselTracking } from './tracking/YouMightAlsoLikeCarouselTracking';
import { ExtrasCarouselTracking } from './tracking/ExtrasCarouselTracking';
import { NewsCarouselTracking } from './tracking/NewsCarouselTracking';
import { trackAction } from 'helpers/trackingOM';

const MOVIES_TEXT = 'movies';

// START AB TEST PLGRWEB-307-SEARCHSCREEN-CAROUSEL
const searchPageCarouselVariants = [
    'test-_web_carousel_test_on_search-hybrid_showmovie_onnow',
    'test-_web_carousel_test_on_search-movies_shows_onnow',
    'test-_web_carousel_test_on_search-personalized_by_hpconfig',
];
// END AB TEST PLGRWEB-307-SEARCHSCREEN-CAROUSEL

export class JsCarouselTracking {
    /**
     *
     * @type {HTMLElement}
     */
    element = null;
    /**
     *
     * @type {JsCarousel}
     * @private
     */
    #carousel = null;
    /**
     *
     * @type {boolean}
     * @private
     */
    #hpDescriptionsTestOn = false;

    /**
     *
     * @type {string}
     * @private
     */
    #title = '';

    /**
     *
     * @type {{CBSNews: NewsCarouselTracking, YouMightAlsoLike: YouMightAlsoLikeCarouselTracking, collectionHubCarousel: CollectionHubCarouselTracking, Brands: BrandsCarouselTracking, MyList: ListCarouselTracking, WatchList: ListCarouselTracking}}
     * @private
     */
    #parsers = {
        collectionHubCarousel: CollectionHubCarouselTracking,
        CBSNews: NewsCarouselTracking,
        Brands: BrandsCarouselTracking,
        MyList: ListCarouselTracking,
        WatchList: ListCarouselTracking,
        YouMightAlsoLike: YouMightAlsoLikeCarouselTracking,
        Extras: ExtrasCarouselTracking,
    };

    /**
     *
     * @param elem {HTMLElement}
     * @param caro { JsCarousel }
     */
    constructor(elem, caro) {
        if (!elem.hasAttribute('has-tracking-listeners')) {
            elem.setAttribute('has-tracking-listeners', 'true');
            this.element = elem;
            this.#carousel = caro;
            this._init();
        }
    }

    /**
     *
     * @private
     */
    _init() {
        const body = document.getElementsByTagName('body')?.[0];
        this.#hpDescriptionsTestOn =
            body?.classList.contains('test-homepage_descriptions_web-description') ?? false;
        this._waitForSwiper();
    }

    /**
     * @private
     */
    _waitForSwiper() {
        if (this.#carousel.options.data) {
            this._addListeners();
            this.#carousel?.swiper?.on('slideNextTransitionEnd', () => {
                this._addListeners();
            });
        } else {
            this.#carousel.getWrapper().on('videoDataLoad', () => {
                this._addListeners();
                this.#carousel?.swiper?.on('slideNextTransitionEnd', () => {
                    this._addListeners();
                });
            });
        }
    }

    /**
     *
     * @param _data
     * @returns {string}
     */
    _getCarouselType(_data) {
        if (CBS.Registry.news) {
            return 'CBSNews';
        }
        if (Array.isArray(_data) && _data?.at(0) === 'collectionHubCarousel') {
            return _data.at(0);
        }
        return this.#title.replace("'", '').replace(/\s/g, '').replace('', '').trim();
    }

    _getCarouselNum(activeTitle) {
        activeTitle = activeTitle.toLowerCase();
        let carousel_num = 0;
        const videoTitles = document.querySelectorAll('.video-section-title');

        activeTitle = activeTitle.toLowerCase();
        videoTitles.forEach((elem, index) => {
            const otLoop = elem.textContent
                .replace("'", '')
                .replace(/\s/g, '')
                .replace('', '')
                .trim();
            if (otLoop.toLowerCase() === activeTitle) {
                carousel_num = index + 1;
            }
        });
        return carousel_num;
    }
    getCurrentPageRowPosition() {
        const $item = $(this.element);
        let mainComponents = $('.hero__wrapper, .grid-view, .js-le-carousel');

        let itemMainParent = $item.parents('.js-le-carousel');
        if (itemMainParent.length === 0) {
            itemMainParent = $item.parents('.grid-view');
        }

        let position = null;
        mainComponents.each(function (index, element) {
            let $element = $(element);
            if ($element.html() === itemMainParent.html()) {
                position = index;
            }
        });

        return position.toString();
    }

    _getCarouselTitle() {
        const $title = this.element.querySelector('h2.video-section-title')?.textContent;
        return $title.replace("'", '').replace(/\s/g, '').replace('', '').trim();
    }
    /**
     *
     */
    _addListeners() {
        this.#title =
            this.element.closest('.carousel')?.querySelector('h2.video-section-title')
                ?.textContent ?? '';

        const links = this.element?.querySelectorAll('a.link');
        if (links && links.length > 0) {
            links.forEach((elem) => {
                if (elem.hasAttribute('has-tracking-listeners')) {
                    return;
                }
                elem.setAttribute('has-tracking-listeners', 'true');
                let data = elem.getAttribute('aa-link');
                let dd = data?.split('|') ?? [];
                let contentTitle = elem
                    .querySelector('.info-wrapper .title-wrapper .title')
                    ?.textContent?.trim();
                let contentTitleArray = contentTitle?.split('|');
                let fathom = elem?.dataset?.fathom?.split('|') ?? [];
                let aalink = [];

                if (contentTitleArray?.length > 1) {
                    dd.forEach((item, index) => {
                        aalink.push(item.toString());
                    });
                } else {
                    aalink = data?.split('|') ?? [];
                }

                elem.addEventListener('click', () => {
                    const carouselType = this._getCarouselType(aalink);
                    const carouselNum = this.getCurrentPageRowPosition();
                    let obj;
                    if (this.#parsers.hasOwnProperty(carouselType)) {
                        obj = new this.#parsers[carouselType](
                            aalink,
                            fathom,
                            this.element,
                            carouselNum,
                            elem,
                        ).parse();
                    } else {
                        obj = new GenericCarouselTracking(
                            aalink,
                            fathom,
                            this.element,
                            carouselNum,
                            elem,
                        ).parse();
                    }
                    if (obj !== false) {
                        window.localStorage.setItem('metadata-video-tracking', JSON.stringify(obj));
                        let loc = window.location.href;
                        let action =
                            loc.indexOf('shows') > -1 ? 'trackShowContent' : 'trackRowHeader';
                        action = loc.indexOf('/collections/') > -1 ? 'trackHubRowHeader' : action;
                        action = loc.indexOf('/live-tv/stream/') > -1 ? 'trackCarouselSelect' : action;

                        if ($(this.element).parents('.kids-carousel').length) {
                            action = 'trackCharacterCarouselSelect';
                            obj.carouselId = Number(aalink[2]).toString();
                            obj.carouselContentType = aalink[6];
                            obj.carouselModel = aalink[7];
                            obj.carouselLink = elem.getAttribute('href');
                            obj.characterTitle = aalink[8];
                            obj.contentBrand = 'na';
                            obj.characterFileName = String(aalink[4]);
                            obj.showSeriesTitle = '';
                            obj.showTitle = '';
                            obj.showSeriesId = '';
                            obj.showSeasonNumber = '';
                            obj.showEpisodeNumber = '';
                            obj.showEpisodeLabel = 'na';
                        } else {
                            action = CBS.Registry.homepage ? 'trackCarouselSelect' : action;
                        }
                        if (!CBS.Registry.homepage) {
                            if (CBS.Registry.videopage) {
                                if (CBS.Registry.Show.id != null) {
                                    action = 'trackShowContent';
                                } else if (CBS.Registry.livetv) {
                                    action = 'trackCarouselSelect';
                                } else {
                                    if (
                                        this._getCarouselType(aalink) === 'YouMightAlsoLike' ||
                                        this._getCarouselType(aalink) === 'Extras'
                                    ) {
                                        action = 'trackRowHeader';
                                    } else {
                                        action = 'trackVideoRowHeader';

                                        if (CBS.Registry.kidsLanding) {
                                            action = 'trackContentGridSelect';
                                            obj.posRowNum = '1';
                                            obj.posColNum = (Number(obj.posColNum) - 1).toString();
                                        }
                                    }
                                }
                            } else {
                                if (CBS.Registry.kidsLanding) {
                                    action = 'trackContentGridSelect';
                                    obj.posRowNum = '1';
                                    obj.posColNum = (Number(obj.posColNum) - 1).toString();
                                }

                                if (CBS.Registry.news) {
                                    action = 'trackNewsRowHeader';
                                }

                                if (CBS.Registry.search) {
                                    action = 'trackSearchCarouselSelect';
                                    obj.posRowNum = this.getCurrentPageRowPosition();
                                }

                                if (CBS.Registry.pageType == 'SHOWHOME') {
                                    action = 'trackNewsRowHeader';
                                    obj.posRowNum = this.getCurrentPageRowPosition();
                                }

                                if (CBS.Registry.brand.name === 'CBS') {
                                    action = 'trackShowContent';
                                    obj.posRowNum = this.getCurrentPageRowPosition();
                                }

                                // START AB TEST EPIC - feature/PLGRWEB-433-ab-test-my-list-carousels
                                if (CBS.Registry.mylist) {
                                    action = 'trackCarouselSelect';
                                }
                                // END AB TEST EPIC - feature/PLGRWEB-433-ab-test-my-list-carousels
                            }
                        }
                        const newBadge = $(this).find('.new-item').text();
                        if (newBadge) {
                            obj = {
                                ...obj,
                                contentBadgeLabel: newBadge,
                                posRowNum: this.getCurrentPageRowPosition(),
                            };
                        }
                        window.localStorage.setItem('metadata-video-tracking', JSON.stringify(obj));
                        if (
                            aalink[0]?.toLowerCase().includes(MOVIES_TEXT) &&
                            obj.carouselContentType !== 'show'
                        ) {
                            let o = {
                                movieTitle: fathom[5],
                                movieId: aalink[16],
                                showGenre: '',
                            };
                            obj = {
                                ...obj,
                                ...o,
                            };
                            delete obj.showSeriesTitle;
                            delete obj.showSeriesId;
                        }

                        if (aalink[1] == 'promoTile') {
                            action = 'trackPromoTileSelect';
                            obj = {
                                promoSpotTitle: aalink[0],
                                ctaText: aalink[2],
                                rowHeaderTitle: obj.rowHeaderTitle,
                                carouselId: obj.carouselId,
                                carouselContentType: 'promo_' + aalink[6],
                                carouselModel: obj.carouselModel,
                                carouselLink: obj.carouselLink,
                                posRowNum: obj.posRowNum,
                                posColNum: obj.posColNum,
                                hubId: aalink[5],
                                showSeriesId: aalink[16],
                                contentLocked: aalink[23],
                            };
                        }

                        // set promoSpotTitle on all carousel items in carousel that has a promo tile
                        let $promoInfo = $(this.element).find('.promoInfo');
                        if ($promoInfo.length) {
                            let promoAAlink =
                                $promoInfo.parents('a.link').attr('aa-link').split('|') ?? [];
                            obj.promoSpotTitle = promoAAlink[0];
                            if (aalink[1] !== 'promoTile') {
                                obj.posColNum = parseInt(obj.posColNum) + 1;
                            }
                        } else {
                            // set empty value in non promo tile having carousels
                            obj.promoSpotTitle = ' ';
                        }

                        trackAction(action, obj);
                    }
                });
            });
        }
    }
}
